import { get } from "lodash";
import { useState } from "react";
import Slider from "./Slider";

const options = { 1: "Économique", 2: "Confort", 3: "Élevé" };
const DESCRIPTIONS = {
  hospitalization: {
    1: "Vous ne souhaitez pas être couvert pour les dépassements d'honoraires, la chambre particulière (en cas d'hospitalisation) et les médecines douces.",
    2: "Vous acceptez un reste à charge pour les dépassements d'honoraires, la chambre particulière (en cas d'hospitalisation) et les médecines douces.",
    3: "Vous ne souhaitez pas ou peu de reste à charge concernant les dépassements d'honoraires, la chambre particulière et les médecines douces.",
  },
  dental: {
    1: "Vous acceptez de supporter un reste à charge qui peut s’avérer élevé en dentaire.",
    2: "Vous avez des besoins en dentaire mais acceptez le principe d'un reste à charge.",
    3: "Vous ne souhaitez pas ou peu de reste à charge pour vos soins dentaires (implants, prothèses, couronnes, orthodontie).",
  },
  optical: {
    1: "Vous acceptez un reste à charge pouvant être important en optique.",
    2: "Vous avez des besoins en optique mais acceptez le principe d'un reste à charge.",
    3: "Vous ne souhaitez pas ou peu de reste à charge pour vos besoins optique.",
  },
  preventionAndWellBeing: {
    1: "Vous n'avez pas de besoins particuliers pour les prothèses médicales et les cures thermales, vous acceptez un reste à charge pouvant être important.",
    2: "Vous souhaitez être couvert pour les appareillages auditifs, les semelles orthopédiques… , vous acceptez le principe d'un reste à charge sur ces postes.",
    3: "Vous ne souhaitez pas ou peu de reste à charge pour les appareillages auditifs, semelles orthopédiques, cures thermales…",
  },
};

const NeedsContent = ({
  categories,
  selectedValues,
  setSelectedValues,
  onClick,
}) => {
  const [description, setDescription] = useState(
    categories.reduce((acc, { value }) => {
      acc[value] = get(DESCRIPTIONS, `${value}.${selectedValues[value]}`);
      return acc;
    }, {}),
  );
  const handleChange = (category, value) => {
    setDescription((prev) => ({
      ...prev,
      [category.value]: get(DESCRIPTIONS, `${category.value}.${value}`),
    }));
    setSelectedValues((prev) => ({ ...prev, [category.value]: value }));
  };

  return (
    <div className="mobilityMutual__needs">
      <div className="mobilityMutual__slides">
        {categories.map((category) => (
          <div key={category.value}>
            <div className="--item">
              <div className="--head">
                <div className="--left">
                  <img src={category.icon} alt="" />
                  <div className="--content">
                    <span>{category.label}</span>
                    <small>{get(description, category.value)}</small>
                  </div>
                </div>
              </div>

              <Slider
                marks={[1, 2, 3]}
                options={options}
                value={selectedValues[category.value]}
                onClick={(value) => {
                  handleChange(category, value);
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Needs = ({
  categories = [],
  selectedValues,
  setSelectedValues,
  onClick,
}) => {
  return (
    <NeedsContent
      categories={categories}
      selectedValues={selectedValues}
      setSelectedValues={setSelectedValues}
      onClick={onClick}
    />
  );
};

export default Needs;
